import React from "react";

export default function Versao1018() {
  return (
    <div className="space-y-6">
      <h2 className="text-lg font-semibold text-green-700">
        Melhorias Recentes – Versão 1.0.18
      </h2>

      <ul className="space-y-4 text-green-700 text-base leading-relaxed">

        <li>
          <strong>👤 Nova Tela de Usuários:</strong>
          <p className="ml-4">
            Tela totalmente dedicada para gerenciar todos os usuários do sistema,
            permitindo visualizar, editar e controlar permissões. 📌
          </p>
        </li>

        <li>
          <strong>🖼️ Foto de Usuário:</strong>
          <p className="ml-4">
            Agora é possível anexar e exibir a foto do usuário diretamente no cadastro.
            A imagem aparece automaticamente no painel do usuário. 📷
          </p>
        </li>

        <li>
          <strong>💬 Chat Interno:</strong>
          <p className="ml-4">
            Módulo de comunicação interna criado — ainda em desenvolvimento.  
            Em breve será possível enviar mensagens e anexos entre setores. 🚀
          </p>
        </li>

      </ul>
    </div>
  );
}
